import { createSlice } from "@reduxjs/toolkit";
import { deleteServiceExpense, fetchServiceExpenseRecord } from "./ServiceExpenseRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE", // later could be dynamic
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const serviceExpenseRecordSlice = createSlice({
  name: "serviceExpenseRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceExpenseRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceExpenseRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchServiceExpenseRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteServiceExpense.fulfilled, (state, action) => {
      const { service_ex_id } = action.payload;
      state.list = state.list.filter(
        (row) => row.id !== service_ex_id
      );
    });
  },
});

export const { setFilters } = serviceExpenseRecordSlice.actions;
export default serviceExpenseRecordSlice.reducer;
